/** 负责人多选：存库仍为字符串，展示/编辑用顿号拼接 */

const FZR_SPLIT = /[、,，;/\s]+/;

export function parseFzrList(value: string | null | undefined): string[] {
  const text = String(value || '').trim();
  if (!text) return [];
  return text
    .split(FZR_SPLIT)
    .map((part) => part.trim())
    .filter(Boolean);
}

export function joinFzrList(names: string[]): string {
  const unique: string[] = [];
  names.forEach((name) => {
    const text = String(name || '').trim();
    if (!text || unique.includes(text)) return;
    unique.push(text);
  });
  return unique.join('、');
}

export function uniqueFzrOptions(values: Array<string | null | undefined>): string[] {
  const set = new Set<string>();
  values.forEach((value) => {
    parseFzrList(value).forEach((name) => set.add(name));
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b, 'zh-CN'));
}
